import styled from 'styled-components';
import {dFlexColumn} from '../../../../globalVariables/GlobalFlex';

export const content = styled.div`
    ${dFlexColumn};
    gap: var(--space-lg);
    padding-inline: var(--space-xl);
`;

export const description = styled.p`
    margin: 0;
    font-size: var(--font-size-body);
    color: var(--color-text-default);
`;

export const badge = styled.button`
    display: block;
    width: 100%;
    max-width: 310px;
    margin-inline: auto;
    aspect-ratio: 31 / 5;
    padding: 0;
    border: none;
    background: none;
    border-radius: var(--border-radius-border-radius-full);
    cursor: pointer;

    & svg {
        display: block;
        width: 100%;
        height: 100%;
    }
`;
